import { corpusSourcesText, formatCount } from "@/features/data-curation/rowLimit";
import type { ExtractionCorpusEstimate } from "@/features/data-curation/types";

/**
 * The papers that the agents read and the rows they made, then the count of the
 * corpus papers that match the search that the agent counted, as inline text.
 * The agent writes that search to give scale; it is not the search that found
 * the papers that the agents read.
 */
export const CorpusCountText = ({
  estimate,
}: {
  estimate?: ExtractionCorpusEstimate | null;
}) => {
  if (estimate?.status !== "running" && estimate?.status !== "complete") return null;
  if (estimate.status === "complete" && estimate.matched_papers == null) return null;
  const read = estimate.papers_read;
  const rows = estimate.rows;
  const search = (
    <>
      papers in {corpusSourcesText(estimate.sources)} match{" "}
      <span className="break-words">
        {estimate.boolean ? estimate.query : `"${estimate.query}"`}
      </span>
    </>
  );
  return (
    <>
      {read > 0 && (
        <>
          The agents read {formatCount(read)} {read === 1 ? "paper" : "papers"} and made{" "}
          {formatCount(rows)} {rows === 1 ? "row" : "rows"} from {read === 1 ? "it" : "them"}.{" "}
        </>
      )}
      {estimate.status === "running" ? (
        <>The agent is still counting how many {search}.</>
      ) : (
        <>
          The agent {read > 0 ? "also counted" : "counted"} how many {search}:{" "}
          {estimate.is_exact ? "" : "at least "}
          {formatCount(estimate.matched_papers ?? 0)}.
        </>
      )}
    </>
  );
};
